import Axios from "axios";

const base_url = "cp/delivers";

export default {
    /**
     * Display a listing of the Delivers.
     *
     * @param {int} page number of page for pagination
     * @param {object} params filter (search) options
     * @returns {Promise}
     */
    getAll(page = 1, params = {}) {
        return Axios.get(`${base_url}?page=${page}`, { params });
    },

    /**
     * Get all delivers with specific properties of delivers.
     *
     * @returns {Promise}
     */
    getAllShort() {
        return Axios.get(`${base_url}/short`);
    },

    /**
     * Store a new Deliver in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    create(data) {
        return Axios.post(base_url, data);
    },

    /**
     * Show data for a given Deliver.
     *
     * @param {int} id
     * @returns {Promise}
     */
    getById(id) {
        return Axios.get(`${base_url}/${id}`);
    },

    /**
     * Update the given Deliver in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    update(data) {
        return Axios.put(`${base_url}/${data.id}`, data);
    }
};
